// Mock data for Data Clouds website

export const services = [
  {
    id: 1,
    title: "Custom Website Development",
    description: "Build fast, scalable, and conversion-optimized websites that drive business growth.",
    icon: "Globe",
    features: ["Responsive Design", "SEO Optimized", "Lightning Fast", "Secure & Scalable"],
    benefits: "Increase online presence by 300% and convert more visitors into customers."
  },
  {
    id: 2,
    title: "Mobile Application Development",
    description: "Native and cross-platform mobile apps that users love and businesses rely on.",
    icon: "Smartphone",
    features: ["iOS & Android", "Cloud Integration", "Push Notifications", "Offline Support"],
    benefits: "Reach 80% of your audience on mobile with seamless user experiences."
  },
  {
    id: 3,
    title: "AI Agents & Intelligent Automation",
    description: "Deploy smart AI agents that understand, learn, and automate complex business tasks.",
    icon: "Bot",
    features: ["Natural Language Processing", "24/7 Automation", "Smart Decision Making", "Self-Learning"],
    benefits: "Reduce operational expenses by 60% while increasing customer satisfaction."
  },
  {
    id: 4,
    title: "Business Process Automation",
    description: "Streamline workflows and eliminate repetitive tasks with intelligent automation.",
    icon: "Workflow",
    features: ["Workflow Automation", "Integration Hub", "Real-time Monitoring", "Custom Solutions"],
    benefits: "Save 40+ hours per week and focus on strategic growth initiatives."
  },
  {
    id: 5,
    title: "Data Analytics & Visualization",
    description: "Transform raw data into actionable insights with powerful analytics tools.",
    icon: "BarChart3",
    features: ["Real-time Dashboards", "Predictive Analytics", "Custom Reports", "Data Integration"],
    benefits: "Make data-driven decisions 10x faster with clear visualizations."
  },
  {
    id: 6,
    title: "Digital Marketing & Business Promotion",
    description: "Strategic digital marketing campaigns that deliver measurable ROI.",
    icon: "TrendingUp",
    features: ["SEO & SEM", "Social Media", "Content Marketing", "Performance Tracking"],
    benefits: "Generate 5x more qualified leads with targeted marketing strategies."
  },
  {
    id: 7,
    title: "Video Advertising & Creative Media",
    description: "Engaging video content that captures attention and drives conversions.",
    icon: "Video",
    features: ["Professional Production", "Motion Graphics", "Brand Storytelling", "Multi-Platform"],
    benefits: "Boost engagement by 400% with compelling video content."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "CEO, TechStart Inc",
    company: "TechStart Inc",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150",
    rating: 5,
    text: "Data Clouds transformed our entire digital infrastructure. Their AI automation saved us 60% in operational expenses while improving customer satisfaction dramatically.",
    results: "60% efficiency improvement, 250% customer satisfaction increase"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Founder, GrowthLabs",
    company: "GrowthLabs",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150",
    rating: 5,
    text: "The custom web platform they built scaled our business exponentially. Exceptional quality and support throughout the entire journey.",
    results: "900% business growth, 10x user engagement"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "COO, DataFlow Systems",
    company: "DataFlow Systems",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150",
    rating: 5,
    text: "Their data analytics platform gave us insights we never knew existed. We're now making decisions 10x faster with complete confidence.",
    results: "10x faster decision making, 45% efficiency gain"
  },
  {
    id: 4,
    name: "David Kumar",
    role: "Director of Technology, FinanceHub",
    company: "FinanceHub",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150",
    rating: 5,
    text: "Best technology partner we've ever worked with. Their mobile app has 4.9 stars and handles millions of transactions seamlessly.",
    results: "4.9 star rating, 2M+ active users"
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "E-commerce Platform Transformation",
    client: "RetailPro Global",
    industry: "E-commerce",
    image: "https://images.unsplash.com/photo-1599413955192-1d5eb8099a9c",
    challenge: "Outdated platform with slow load times and poor conversion rates",
    solution: "Built modern, fast web platform with AI-powered recommendations",
    results: {
      metric1: "350% increase in conversion rate",
      metric2: "2.5s average load time",
      metric3: "5x order volume growth"
    },
    technologies: ["React", "Node.js", "AI/ML", "AWS"],
    duration: "4 months"
  },
  {
    id: 2,
    title: "School Management System",
    client: "Bright Future Academy",
    industry: "Education - School",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b",
    challenge: "Manual attendance, grade tracking, and parent communication",
    solution: "Complete digital school management platform with student portal, attendance automation, and parent mobile app",
    results: {
      metric1: "90% reduction in admin workload",
      metric2: "98% parent engagement rate",
      metric3: "500+ students digitally managed"
    },
    technologies: ["React", "FastAPI", "MongoDB", "Mobile App"],
    duration: "3 months"
  },
  {
    id: 3,
    title: "College Learning Management System",
    client: "Pioneer College of Technology",
    industry: "Education - College",
    image: "https://images.unsplash.com/photo-1723987135977-ae935608939e",
    challenge: "Inefficient online learning and student engagement tracking",
    solution: "AI-powered LMS with virtual classrooms, automated grading, and analytics dashboard for 2000+ students",
    results: {
      metric1: "85% student engagement increase",
      metric2: "24/7 accessible learning",
      metric3: "60% faster assignment grading"
    },
    technologies: ["React", "Python", "AI/ML", "WebRTC", "AWS"],
    duration: "5 months"
  },
  {
    id: 4,
    title: "Business Process Automation",
    client: "TechCorp Industries",
    industry: "Manufacturing",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
    challenge: "Manual inventory tracking and order processing causing delays",
    solution: "Automated workflow system with real-time inventory, AI-powered demand forecasting, and supplier integration",
    results: {
      metric1: "70% reduction in processing time",
      metric2: "95% inventory accuracy",
      metric3: "40 hours saved per week"
    },
    technologies: ["Python", "FastAPI", "PostgreSQL", "Machine Learning"],
    duration: "4 months"
  },
  {
    id: 5,
    title: "Healthcare AI Assistant",
    client: "MediCare Solutions",
    industry: "Healthcare",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d",
    challenge: "Manual patient support overwhelming staff, long wait times",
    solution: "Deployed AI chatbot with medical knowledge and appointment scheduling",
    results: {
      metric1: "85% reduction in wait times",
      metric2: "24/7 patient support",
      metric3: "92% satisfaction score"
    },
    technologies: ["GPT-4", "Python", "FastAPI", "MongoDB"],
    duration: "3 months"
  },
  {
    id: 6,
    title: "Restaurant Chain Management Platform",
    client: "Foodie Express Chain",
    industry: "Restaurant Business",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4",
    challenge: "Managing 15 restaurant locations with inconsistent operations",
    solution: "Centralized platform for inventory, staff scheduling, and customer orders with real-time analytics",
    results: {
      metric1: "50% reduction in food waste",
      metric2: "35% increase in efficiency",
      metric3: "Real-time multi-location tracking"
    },
    technologies: ["React", "Node.js", "MongoDB", "Mobile App"],
    duration: "4 months"
  },
  {
    id: 7,
    title: "Financial Analytics Dashboard",
    client: "InvestSmart Capital",
    industry: "Finance",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71",
    challenge: "Complex data scattered across multiple systems",
    solution: "Unified analytics platform with real-time insights and predictions",
    results: {
      metric1: "10x faster reporting",
      metric2: "95% accuracy in predictions",
      metric3: "75% operational efficiency gain"
    },
    technologies: ["Python", "Power BI", "Azure", "Machine Learning"],
    duration: "5 months"
  },
  {
    id: 8,
    title: "Mobile Banking App",
    client: "NextGen Bank",
    industry: "Banking",
    image: "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f",
    challenge: "Need modern mobile experience for digital-first customers",
    solution: "Native iOS and Android apps with biometric security and instant transfers",
    results: {
      metric1: "500K downloads in 3 months",
      metric2: "4.8 app store rating",
      metric3: "70% mobile transaction rate"
    },
    technologies: ["React Native", "Node.js", "PostgreSQL", "AWS"],
    duration: "6 months"
  }
];

export const stats = [
  { label: "Projects Delivered", value: "500+", icon: "CheckCircle" },
  { label: "Client Satisfaction", value: "98%", icon: "Star" },
  { label: "Industries Served", value: "15+", icon: "Globe" },
  { label: "Expert Team Members", value: "50+", icon: "Users" }
];

export const technologies = [
  "React", "Node.js", "Python", "FastAPI", "MongoDB", "PostgreSQL",
  "AWS", "Azure", "Google Cloud", "Docker", "Kubernetes",
  "TensorFlow", "PyTorch", "OpenAI", "Next.js", "TypeScript"
];

export const faqs = [
  {
    id: 1,
    question: "How long does a typical project take?",
    answer: "Project timelines vary based on complexity. A standard website takes 4-6 weeks, mobile apps 8-12 weeks, and enterprise solutions 3-6 months. We provide detailed timelines during our discovery phase."
  },
  {
    id: 2,
    question: "Do you provide ongoing support after launch?",
    answer: "Yes! We offer comprehensive maintenance packages including updates, security patches, performance optimization, and 24/7 support. Our team ensures your solution stays current and performs optimally."
  },
  {
    id: 3,
    question: "What industries do you specialize in?",
    answer: "We serve diverse industries including e-commerce, healthcare, finance, education (schools & colleges), restaurants, manufacturing, and more. Our team has deep expertise across multiple sectors and can adapt to any business domain."
  },
  {
    id: 4,
    question: "How do you ensure project success?",
    answer: "We follow agile methodology with weekly sprints, regular client reviews, and transparent communication. You'll have a dedicated project manager and access to our project dashboard for real-time progress tracking."
  },
  {
    id: 5,
    question: "What makes Data Clouds different?",
    answer: "Our unique combination of technical excellence, business acumen, and client-first approach. We don't just build technology—we deliver business outcomes with measurable ROI and long-term partnerships."
  }
];

export const whatsappNumber = "+9779802891106";

// Chat mock responses (will be replaced with real AI)
export const mockChatResponses = {
  greeting: "Hello! I'm the Data Clouds AI assistant. How can I help you transform your business today?",
  services: "We offer 7 core services: Custom Website Development, Mobile Apps, AI Agents, Business Automation, Data Analytics, Digital Marketing, and Video Advertising. Which one interests you?",
  consultation: "Let's schedule a free consultation to discuss your requirements and create a customized solution that fits your needs perfectly.",
  timeline: "Project timelines depend on complexity: Websites (4-6 weeks), Mobile Apps (8-12 weeks), Enterprise Solutions (3-6 months). We can provide a detailed timeline after understanding your requirements.",
  default: "That's a great question! I'd love to discuss this in detail. You can book a free strategy call or contact us via WhatsApp at +977 980 289 1106."
};
